import { Component, EventEmitter, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-bloqueomasivo',
  templateUrl: './bloqueomasivo.component.html',
  styleUrls: ['./bloqueomasivo.component.scss']
})
export class BloqueomasivoComponent {
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  @Output() cerrarPopupBloqueo= new EventEmitter<boolean>();
  frmMeta : FormGroup;

  CerrarVentana(){
    this.cerrarPopupBloqueo.emit();
  }
}
